export const fineGrainedPermissionsKeys = {
  EMPLOYEE: {
    BULKUPLOAD: {
      module: "employee",
      action: "employee-bulk",
    },
    ADDNEW: {
      module: "employee",
      action: "add",
    },
    DETAILS: {
      module: "employee",
      action: "details",
    },
    HIERARCHY: {
      module: "employee",
      action: "hierarchy/upper",
    },
    EDIT: {
      module: "employee",
      action: "edit",
    },
    "INACTIVE/ACTIVE": {
      module: "employee",
      action: "edit",
    },
  },
  PRODUCT: {
    ADD: {
      module: "product",
      action: "add",
    },
    DETAILS: {
      module: "product",
      action: "details",
    },
    GETPRODUCTPRICE: {
      module: "product",
      action: "get-product-price",
    },
    "PRICE/ADD": {
      module: "product",
      action: "price/add",
    },
    "PRICE/DELETE": {
      module: "product",
      action: "price/edit",
    },
    POGENERATION: {
      module: "product",
      action: "po-generation",
    },
    PRODUCTVISIBILITY: {
      module: "product",
      action: "region/visiblity",
    },
    "INACTIVE/ACTIVE": {
      module: "product",
      action: "edit",
    },
    EDIT: {
      module: "product",
      action: "edit",
    },
    ALTERNATEITEMCODES: {
      module: "product",
      action: "alternate-item-codes",
    },
    ALTERNATEUPDATE: {
      module: "product",
      action: "alternate-update",
    },
  },
  COUNTER: {
    BULKUPLOAD: {
      module: "counter",
      action: "counter-bulk",
    },
    ADDNEW: {
      module: "counter",
      action: "add",
    },
    BLOCK: {
      module: "counter",
      action: "block",
    },
    REVOKE: {
      module: "counter",
      action: "revoke",
    },
    // M10-15114
     BLOCKREVOKE: {
      module: "counter",
      action: "block-revoke",
    },
    // M10-15114
    // M10-15114
    ACTIONREVOKE: {
      module: "counter",
      action: "action-revoke",
    },
    // M10-15114
    EDITCOUNTER: {
      module: "counter",
      action: "edit",
    },
    //M10-15603
    ADDGST: {
      module: "counter",
      action: "add-gst",
    },
    //M10-15603
    MERGE: {
      module: "counter",
      action: "merge",
    },
    INACTIVE: {
      module: "counter",
      action: "deactivate",
    },
    DETAILS: {
      module: "counter",
      action: "details",
    },
    EDITLOCATION: {
      module: "counter",
      action: "location/edit",
    },
    DELETELOCATION: {
      module: "counter",
      action: "location/delete",
    },
    COMPANIES: {
      module: "counter",
      action: "companylink",
    },
    ADDCOMPANY: {
      module: "counter",
      action: "company/add",
    },
    //M10-15535
    EXCEPTIONALPH: {
      module: "counter",
      action: "company/execptional-ph",
    },
    //M10-15535
    BLOCKCOMPANY: { module: "counter", action: "company/block" },
    DEACTIVATECOMPANY: {
      module: "counter",
      action: "company/deactivate",
    },
    COMPANYCONFIGURATION: {
      module: "counter",
      action: "company/configuration",
    },
    // M10-14969
    MULTISTOCKISTCOUNT: {
      module: "counter",
      action: "company/multi-stockist-count",
    },
    // M10-14969
    DIVISIONBLOCK: {
      module: "counter",
      action: "division/block",
    },
    DEACTIVATEDIVISION: {
      module: "counter",
      action: "deactivate/division",
    },
    ADDDIVISION: {
      module: "counter",
      action: "division/add",
    },
    EDITDIVISION: {
      module: "counter",
      action: "division/edit",
    },
    RCEXPIRYDATEEDIT: {
      module: "counter",
      action: "division/rc-expiry-edit",
    },
    DIVISIONVALUECAP: {
      module: "counter",
      action: "value-cap",
    },
    DIVISIONADDVALUECAP: {
      module: "counter",
      action: "ordercap/add",
    },
    //M10-16010
    COUNTERMASTERTAB: {
      module: "counter",
      action: "counters",
    },
    VALUECAPFREEZETAB: {
      module: "counter",
      action: "valuecapfreeze",
    },
    VALUECAPFREEZEADD: {
      module: "counter",
      action: "valuecapfreeze/add-new",
    },
    VALUECAPFREEZEEDIT: {
      module: "counter",
      action: "valuecapfreeze/edit",
    },
    VALUECAPFREEZEDELETE: {
      module: "counter",
      action: "valuecapfreeze/delete",
    },
    //M10-16010
    DELEGATESVIEW: {
      module: "counter",
      action: "delegate",
    },
    DELEGATESADD: {
      module: "counter",
      action: "delegate/add",
    },
    PRODUCTSVIEW: {
      module: "counter",
      action: "product",
    },
    PRODUCTSADD: {
      module: "counter",
      action: "product/add",
    },
    PRODUCTSEDIT: {
      module: "counter",
      action: "product/edit",
    },
    PRODUCTSBULKEDIT: {
      module: "counter",
      action: "product/bulk-edit",
    },
    PRODUCTSDELETE: {
      module: "counter",
      action: "product/delete",
    },
    PRODUCTSBULKDELETE: {
      module: "counter",
      action: "product/bulk-delete",
    },
    PRICEIDENTIFIEREXEMPT: { module: "counter", action: "product/priceidentifier-exempt" },
    STOCKISTSVIEW: {
      module: "counter",
      action: "stockist-link",
    },
    STOCKISTSADD: {
      module: "counter",
      action: "stockist/add",
    },
    SKILLEDSTOCKISTS: {
      module: "counter",
      action: "stockist/skilled-stockist",
    },
    "STOCKISTSINACTIVE/ACTIVE/DEFAULT": {
      module: "counter",
      action: "stockist/active-inactive",
    },
    CREATESECONDLOCATION: {
      module: "counter",
      action: "location/add",
    },
    //M10-16238
    ADDHOSPITALGROUP: {
      module: "counter",
      action: "add-hospital-group",
    },
    EDITHOSPITALGROUP: {
      module: "counter",
      action: "edit-hospital-group",
    },
    //M10-16238
    ROLESANDPERMISSION: {
      module: "counter",
      action: "roles-permission",
    },
    DASHBOARD: {
      module: "counter",
      action: "dashboard",
    },
    LUPINDASHBOARD: {
      module: "counter",
      action: "lupin-dashboard",
    },
  },
  STOCKIST: {
    DETAILS: {
      module: "stockist",
      action: "details",
    },
    ADD: {
      module: "stockist",
      action: "add",
    },
    "EDIT/ACTIVE/INACTIVE": {
      module: "stockist",
      action: "edit",
    },
    ADDCOMPANY: {
      module: "stockist",
      action: "company/add",
    },
    "EDIT/ACTIVE/INACTIVECOMPANY": { module: "stockist", action: "company/edit" },
  },
  DIVISION: {
    DETAILS: {
      module: "division",
      action: "details",
    },
    VIEWCREQHIERARCHY: {
      module: "division",
      action: "counterdraft/details",
    },
    VIEWPREQHIERARCHY: {
      module: "division",
      action: "productdraft/details",
    },
    VIEWORDERHIERARCHY: {
      module: "division",
      action: "orderdraft/details",
    },
    ADDDELETECREQHIERARCHY: {
      module: "division",
      action: "counter_draft_hierarchy/add",
    },
    ADDDELETEPREQHIERARCHY: {
      module: "division",
      action: "product_draft_hierarchy/add",
    },
    ADDDELETEORDERHIERARCHY: {
      module: "division",
      action: "order_draft_hierarchy/add",
    },
    ADD: {
      module: "division",
      action: "add",
    },
    EDIT: {
      module: "division",
      action: "edit",
    },
  },
  GEOGRAPHY: {
    "ADDSTATE": {
      module: "state",
      action: "add",
    },
    "ADDDISTRICT": {
      module: "state",
      action: "district/add",
    },
    "ADDCITY": {
      module: "state",
      action: "city/add",
    },
    "EDIT/ACTIVE/INACTIVEDISTRICT": {
      module: "state",
      action: "district/edit",
    },
    "EDIT/ACTIVE/INACTIVECITY": {
      module: "state",
      action: "city/edit",
    },
    "REPLACECITY": {
      module: "state",
      action: "city/replace",
    },
  },
  CRA: {
    ADDNEW: {
      module: "cda",
      action: "add",
    },
    PENDING: {
      module: "cda",
      action: "counter/request",
    },
    "ACCEPT/REJECT": {
      module: "cda",
      action: "counter/request/status/update",
    },
    APPROVEDBYME: {
      module: "cda",
      action: "counter/request",
    },
  },
  PRA: {
    DETAILS_ALL: { module: "productrequest", action: "details/all" },
    DRAFT: { module: "productrequest", action: "details" },
    DETAILS: { module: "productrequest", action: "details" },
    HIERARCHY: { module: "productrequest", action: "hierarchy" },
    VIEWREMARKS: { module: "productrequest", action: "request-comment" },
    ADDREMARKS: { module: "productrequest", action: "request-comment" },
    EDIT: { module: "productrequest", action: "edit" },
    DELETE: { module: "productrequest", action: "delete" },
    APPROVE: { module: "productrequest", action: "approve" },
    REJECT: { module: "productrequest", action: "reject" },
  },
  ORDER: {
    DETAILS_ALL: {
      module: "order",
      action: "details_all",
    },
    FUID: {
      module: "order",
      action: "fuids",
    },
    INVOICES: {
      module: "order",
      action: "fuids",
    },
    VIEWHIERARCHY: {
      module: "order",
      action: "hierarchy",
    },
    VIEWREMARKS: {
      module: "order",
      action: "remarks",
    },
    ADDREMARKS: {
      module: "order",
      action: "remarks",
    },
    SENDEMAIL: {
      module: "order",
      action: "novu",
    },
    UPDATEORDERTYPE: {
      module: "order",
      action: "update-order-type",
    },
    UPDATESTOCKIST: {
      module: "order",
      action: "replace-stockist",
    },
    UPDATECASHDISCOUNT: {
      module: "order",
      action: "update-cash-discount",
    },
    UPDATEORDERSTATUS: {
      module: "order",
      action: "update-order-status",
    },
    UPDATECOUNTERLOCATION: { module: "order", action: "location-shift" },
    ORDERAPPROVE: {
      module: "order",
      action: "approve",
    },
    ORDERREJECT: {
      module: "order",
      action: "reject",
    },
    ORDERINITIATE: {
      module: "order",
      action: "/",
    },
    ORDERBULKUPLOADKAM:{
      module: "order",
      action: "order-bulk-upload-kam",
    },
    //M10-15149
    PROCESSEDPODETAILS: {
      module: "order",
      action: "processed-details",
    },
    //M10-15149
    // PO-REJECTION-RESTRUCTURE — counter_po (Orders-->PO tab) reject/revoke/re-edit,
    // not the Purchase Order section's own "po" module.
    COUNTERPOREJECT: {
      module: "order",
      action: "counter_po/reject",
    },
    COUNTERPOREJECTIONREVOKE: {
      module: "order",
      action: "counter_po/rejection-revoke-action",
    },
    COUNTERPOREJECTIONREEDIT: {
      module: "order",
      action: "counter_po/rejection-re-edit-action",
    },
    // COUNTER-PO-REVERT: reverts an Approved/Processed counter PO back to Pending
    COUNTERPOREVERT: {
      module: "order",
      action: "counter_po/revert",
    },
    //M10-15571
    EINVEXEMPT: {
      module: "order",
      action: "einv-exempt",
    },
    EWAYEXEMPT: {
      module: "order",
      action: "eway-exempt",
    },
    //M10-15571
    SKIPNOTIFICATIONS: {
      module: "order",
      action: "skip-notifications",
    },
    //M10-16361 - Order Placed Date
    ORDERPLACEDDATE: {
      module: "order",
      action: "order-placed-date",
    },
    STOCKIST_SAO_ACK: {
      module: "order",
      action: "stockist-sao-ack",
    },
    //M10-16393 — increase/decrease order quantities while approving
    EDITQUANTITY: {
      module: "order",
      action: "edit-quantity",
    },
  },
  INVOICE: {
    ENTRY: {
      module: "invoice",
      action: "stockist_attachment/all",
    },
    APPROVAL: {
      module: "invoice",
      action: "stockist_attachment/all",
    },
    // KAM CN-ADVICE changes: tab-level right for the Entry > "Feedback from Ext" sub-tab.
    // View reveals the tab; Edit enables the per-line Mark-Resolved action. Granted from the
    // admin Access Manager against menu_name "Transactions-->Invoices-->Feedback from Ext".
    "FEEDBACK FROM EXT": {
      module: "invoice",
      action: "kam-feedback-ext",
    },
    "VIEW DETAILS": {
      module: "invoice",
      action: "stockist_attachment/details",
    },
    REASSIGN: {
      module: "invoice",
      action: "stockist_attachment/reassign",
    },
    "PUT ON HOLD": {
      module: "invoice",
      action: "stockist_attachment/hold",
    },
    REJECT: {
      module: "invoice",
      action: "stockist_attachment/reject",
    },
    ESCALATE: {
      module: "invoice",
      action: "stockist_attachment/escalate",
    },
    "SETPRIORITY/REMOVEPRIORITY": {
      module: "invoice",
      action: "stockist_attachment/set-priority",
    },
    VIEWREMARKS: {
      module: "invoice",
      action: "remarks",
    },
    ADDREMARKS: {
      module: "invoice",
      action: "remark",
    },
    UPDATEINVOICESTATUS: {
      module: "invoice",
      action: "status-update",
    },
    SUBMITINVOICE: {
      module: "invoice",
      action: "add",
    },
    "UPDATE/APPROVEINVOICE": {
      module: "invoice",
      action: "edit",
    },
    CONFIRMINVOICE: {
      module: "invoice",
      action: "entry",
    },
    REVERTINVOICE: {
      module: "invoice",
      action: "“revert",
    },
    REMOVEINVOICE: {
      module: "invoice",
      action: "“recall",
    },
    REMOVEPO: {
      module: "invoice",
      action: "remove-po"
    },
    REENTRY: {
      module: "invoice",
      action: "re-entry"
    },
    STOCKIST_ACK: {
      module: "invoice",
      action: "stockist-ack"
    },
    RENAMEINVOICENUMBER: {
      module: "invoice",
      action: "rename-invoice-number"
    },
    INVOICEPREDATE: {
      module: "invoice",
      action: "invoice-pre-date",
    },
    EDITCOUNTER: {
      module: "invoice",
      action: "edit-counter",
    },
    // M10-15486
    "UNVERIFIED E-INVOICES": {
      module: "invoice",
      action: "un-einv-view",
    },
    "EINV CAT3": {
      module: "invoice",
      action: "einvcat3-view",
    },
    // M10-15486
    //M10-11654
    "ROUND ROBIN": {
      module: "invoice",
      action: "round-robin-view",
    },
    //M10-11654
  },
  "PURCHASEORDER": {
    VIEWPODETAILS: {
      module: "po",
      action: "details"
    },
    POGENERATE: {
      module: "po",
      action: "po-generate",
    },
    STOCKISTBLOCKREVOKE: {
      module: "po",
      action: "stockist_block",
    },
    ORDERTYPEEXCEPTION: {
      module: "po",
      action: "order-type-exception",
    },
    //M10-15933
    MARGINTYPEEXCEPTION: {
      module: "po",
      action: "margin-type-exception",
    },
    //M10-15933
    STOCKPOSITION: {
      module: "po",
      action: "stock-position",
    },
    GENERATEPO: {
      module: "po",
      action: "generate",
    },
    STOCKISTBLOCKREVOKEADD: {
      module: "po",
      action: "stockist_block/add",
    },
    ORDERTYPEEXCEPTIONADD: {
      module: "po",
      action: "order-type-exception/add-order-type-exception", //M10-16121
    },
    //M10-16121
    ORDERTYPEEXCEPTIONEDIT: {
      module: "po",
      action: "order-type-exception/edit-order-type-exception",
    },
    ORDERTYPEEXCEPTIONDELETE: {
      module: "po",
      action: "order-type-exception/delete-order-type-exception",
    },
    //M10-16121
  },
  Reconciliation: {
    VIEWRECONCILIATIONDETAILS: {
      module: "reconciliation",
      action: "reconciliation-all"
    },
    SUBMITRECONCILIATION: {
      module: "reconciliation",
      action: "file-reconcile"
    }
  },
  REPORTS: {
    STOCKISTMASTER: {
      module: "report",
      action: "masters/stockist-master"
    },
    PRODUCT_MASTER: {
      module: "report",
      action: "masters/product-master"
    },
    PRODUCTPRICE_MASTER: {
      module: "report",
      action: "masters/product-price-master"
    },
    FF_MASTER: {
      module: "report",
      action: "masters/ff-master"
    },
    CREQ: {
      module: "report",
      action: "request-approval/creq"
    },
    PREQ: {
      module: "report",
      action: "request-approval/preq"
    },
    CREQPREQSUMMARY: {
      module: "report",
      action: "request-approval/creq-preq-summary"
    },
    COUNTERPROFILE: {
      module: "report",
      action: "request-approval/counter-profile"
    },
    CREQMASTERSREPORT: {
      module: "report",
      action: "request-approval/creq-masters-report"
    },
    COMPANYWISECOUNTERCREATIONREPORT: {
      module: "report",
      action: "request-approval/company-wise-counter-creation-report"
    },
    USERWISECOUNTERCREATIONREPORT: {
      module: "report",
      action: "request-approval/user-wise-counter-creation-report"
    },
    COUNTERPRODUCTWITHSKU: {
      module: "report",
      action: "counter/counter-product-with-sku"
    },
    COUNTERPRODUCTWITHOUTSKU: {
      module: "report",
      action: "counter/counter-product-without-sku"
    },
    COUNTERSTOCKIST: {
      module: "report",
      action: "counter/counter-stockist"
    },
    COUNTERORDERCAPSUMMARY: {
      module: "report",
      action: "counter/counter-ordercap-summary"
    },
    COUNTERBLOCKREPORT: {
      module: "report",
      action: "counter/counter-block-report"
    },
    COUNTERREVOKEREPORT: {
      module: "report",
      action: "counter/counter-revoke-report"
    },
    COUNTERPRODUCTCHANGES: {
      module: "report",
      action: "counter/counter-product-changes"
    },
    COUNTER2NDLOC: {
      module: "report",
      action: "counter/counter-2nd-location"
    },
    COUNTERWISEATTACHMENTCNT: {
      module: "report",
      action: "counter/counter-wise-attachment-count"
    },
    USERWISEATTACHMENTCNT: {
      module: "report",
      action: "counter/user-wise-attachment-count"
    },
    COUNTEREDITDETAILS: {
      module: "report",
      action: "counter/counter-edit-details"
    },
    COUNTERVISIT: {
      module: "report",
      action: "counter/counter-visit"
    },
    COUNTERADDITIONALATTACHMENT: {
      module: "report",
      action: "counter/counter-additional-attachment"
    },
    RCAPIREPORTGLENMARK: {
      module: "report",
      action: "counter/rc-api-report-glenmark"
    },
    ORDERDETAILS: {
      module: "report",
      action: "transactions/order-details"
    },
    ORDERBYCOUNTER: {
      module: "report",
      action: "transactions/order-by-counter"
    },
    EXPECTEDPO: {
      module: "report",
      action: "transactions/expected-po"
    },
    PODETAILS: {
      module: "report",
      action: "transactions/po-details"
    },
    MARGINEXCEPTIONREPORT: {
      module: "report",
      action: "transactions/margin-exception-report"
    },
    BOXPACK: {
      module: "report",
      action: "transactions/box-pack"
    },
    STOCKISTRECONCILIATION: {
      module: "report",
      action: "transactions/stockist-reconciliation"
    },
    STOCKISTRECONCILIATIONV2: {
      module: "report",
      action: "transactions/stockist-reconciliation-v2"
    },
    EINVCAT1REPORT: {
      module: "report",
      action: "transactions/einv-cat1-report"
    },
    EINVCAT23REPORT: {
      module: "report",
      action: "transactions/einv-cat2-3-report"
    },
    INVOICEAPPROVALPENDING: {
      module: "report",
      action: "transactions/invoice-approval-pending"
    },
    KAMFUIDDETAILS: {
      module: "report",
      action: "transactions/kam-fuid-details"
    },
    KAMORDERPODETAILS: {
      module: "report",
      action: "transactions/kam-order-po-details"
    },
    INSTORDERPREQSTATUS: {
      module: "report",
      action: "transactions/inst-order-preq-status"
    },
    STOCKISTSALESSTATEMENT: {
      module: "report",
      action: "transactions/stockist-sales-statement"
    },
    FUIDREJECTEDREPORT: {
      module: "report",
      action: "transactions/fuid-rejected-report"
    },
    ORDERSTOCKISTCHANGE: {
      module: "report",
      action: "transactions/order-stockist-change"
    },
    FUIDDETAILSREPORT: {
      module: "report",
      action: "transactions/fuid-details-report"
    },
    AUTONOMOUSDATAVERIFICATIONREPORT: {
      module: "report",
      action: "transactions/autonomous-data-verification-report"
    },
    INVOICEHEADERINFORMATIONREPORT: {
      module: "report",
      action: "transactions/invoice-header-information-report"
    },
    APPMOANALYSIS: {
      module: "report",
      action: "transactions/app-mo-analysis-report"
    },
    KAMCNREPORT: {
      module: "report",
      action: "transactions/kam-cn-report"
    },
    ESCALATEDTOMASTERS: {
      module: "report",
      action: "transactions/escalated-to-masters"
    },
    INVOICEREVIEWBYCOMPANY: {
      module: "report",
      action: "transactions/invoice-review-by-company"
    },
    INVOICEREVIEWPENDINGBYCOMPANY: {
      module: "report",
      action: "transactions/invoice-review-pending-by-company"
    },
    ORDERSAPPROVALBYMV: {
      module: "report",
      action: "transactions/orders-approval-by-mv"
    },
    INVOICEDETAILSKAMLUPIN: {
      module: "report",
      action: "transactions/invoice-details-kam-lupin"
    },
    STOCKISTINVOICEUPLOADCONFIRMATION: {
      module: "report",
      action: "masters/stockist-invoice-upload-confirmation"
    },
    COUNTERMASTER: {
      module: "report",
      action: "masters/counter-master"
    },
    PRODUCTBLOCKREPORT: {
      module: "report",
      action: "masters/product-block-report"
    },
    EXPECTED: {
      module: "report",
      action: "settlements/expected"
    },
    RELEASED: {
      module: "report",
      action: "settlements/released"
    },
    SETTLED: {
      module: "report",
      action: "settlements/settled"
    },
    SEARCH: {
      module: "report",
      action: "settlements/search"
    }
  }
};
